import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect } from "react";
import { cachearContexto } from "../../helpers/cachearContexto";
import MotivoRetrocessoEtapaService from "../../services/MotivoRetrocessoEtapaService";
import { MotivoRetrocessoEtapaType } from "../../types/MotivoRetrocessoType";

interface MotivoRetrocessoEtapaContextProps {
  listaMotivoRetrocessoEtapa: MotivoRetrocessoEtapaType[];
  setListaMotivoRetrocessoEtapa: Dispatch<SetStateAction<MotivoRetrocessoEtapaType[]>>
  handleAtualizarMotivoRetrocessoEtapa: (motivoRetrocesso:any, idMotivoMotivoRetrocessoEtapa?:number) => void;
  handleRemoveMotivoRetrocessoEtapa: (idMotivoMotivoRetrocessoEtapa:number) => void;
}

export const MotivoRetrocessoEtapaContext = createContext({} as MotivoRetrocessoEtapaContextProps);

export function MotivoRetrocessoEtapaProvider({ children }: { children: ReactElement }) {
  const [listaMotivoRetrocessoEtapa, setListaMotivoRetrocessoEtapa] = useState<MotivoRetrocessoEtapaType[]>([] as MotivoRetrocessoEtapaType[]); 

  const handleAtualizarMotivoRetrocessoEtapa = (motivoRetrocesso:any, idMotivoRetrocessoEtapa?:number) => {
    if(idMotivoRetrocessoEtapa){
      setListaMotivoRetrocessoEtapa((current) => {
        return ordenar(current.map((item) => {
           if(item?.id_motivo_retrocesso_etapa === idMotivoRetrocessoEtapa){
             return motivoRetrocesso;
           }
           return item;
        }))
      })
    }else{
      setListaMotivoRetrocessoEtapa((current) => ordenar([motivoRetrocesso, ...current]));
    }
  }
  
  const ordenar = (motivos:MotivoRetrocessoEtapaType[]) => {
    return motivos.sort((a, b) => {return a.descricao < b.descricao ? 1 : -1})
  } 
  const handleRemoveMotivoRetrocessoEtapa = (idMotivoRetrocessoEtapa:number) => {
    setListaMotivoRetrocessoEtapa((current) => current.filter((item) => item.id_motivo_retrocesso_etapa !== idMotivoRetrocessoEtapa));
  }

  return (
      <MotivoRetrocessoEtapaContext.Provider
        value={{
          listaMotivoRetrocessoEtapa,
          setListaMotivoRetrocessoEtapa,
          handleAtualizarMotivoRetrocessoEtapa,
          handleRemoveMotivoRetrocessoEtapa
        }}
      >
          {children}
      </MotivoRetrocessoEtapaContext.Provider>
  );
}
